"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

function checkIfAllEqual(opts1, opts2) {
  if (opts1.length !== opts2.length) {
    return false;
  }

  if (opts1.length === 0) {
    return true;
  }

  var _loop = function _loop(i) {
    var opt1 = opts1[i];
    var mirror = lodash_1.default.findLast(opts2, function (u) {
      return checkIfEqual(opt1, u);
    });

    if (mirror !== undefined) {
      return {
        v: false
      };
    }
  };

  for (var i = 0; i < opts1.length; i++) {
    var _ret = _loop(i);

    if (typeof _ret === "object") return _ret.v;
  }

  return true;
}

exports.checkIfAllEqual = checkIfAllEqual;

function checkIfEqual(opt1, opt2) {
  return lodash_1.default.isEqual(opt2.option, opt1.option) && lodash_1.default.isEqual(opt2.compare, opt1.compare) && lodash_1.default.isEqual(opt2.meta, opt1.meta);
}

exports.checkIfEqual = checkIfEqual;

function getCompare(selected, meta, option) {
  var found = lodash_1.default.find(selected, function (u) {
    return lodash_1.default.isEqual(u.meta, meta) && lodash_1.default.isEqual(u.option, option);
  });
  return !!found ? found.compare : null;
}

exports.getCompare = getCompare;

function getSelected(selected, meta, option) {
  return lodash_1.default.find(selected, function (u) {
    return lodash_1.default.isEqual(u.meta, meta) && lodash_1.default.isEqual(u.option, option);
  });
}

exports.getSelected = getSelected;

function filterByLabel(list, label) {
  return lodash_1.default.filter(list, function (item) {
    return item.meta.label === label;
  });
}

exports.filterByLabel = filterByLabel;

function filterUserInputsByLabel(list, label) {
  return lodash_1.default.filter(list, function (item) {
    return item.meta.label === label;
  });
}

exports.filterUserInputsByLabel = filterUserInputsByLabel;